// colors
export const primary = "#b3294e";
export const secondary = "#4829B2";
export const black = "#000";
export const darkBlack = "#333";
export const background = "#f5f5f5";
export const warningLight = "rgba(253, 200, 69, .3)";
export const warningMain = "rgba(253, 200, 69, .5)";
export const warningDark = "rgba(253, 200, 69, .7)";